import { useField } from '@framework/form/field/useField.tsx';
import {
  type ISwitchInputProps,
  SwitchInput,
} from '@framework/form/inputs/SwitchInput.tsx';
import { useEffect } from 'react';
import { useWatch } from 'react-hook-form';
import { $InputContainer } from './FieldDatatypeBooleanInput.style.tsx';

export interface IFieldDatatypeBooleanInputProps extends ISwitchInputProps {}

export function FieldDatatypeBooleanInput(
  props: IFieldDatatypeBooleanInputProps,
) {
  const value = useWatch({ name: props.name });
  const field = useField(props.name);

  // Quando lo utilizziamo nel ConditionArgumentInput, il valore iniziale è null
  // questo causa problemi (per impostarlo a false andrebbe selezionato e deselezionato).
  // Usiamo un effect che in automatico lo imposta a false così da assicurarci un default.
  useEffect(() => {
    if (value == null) {
      field.setValue(false);
    }
  }, [field, value]);

  return (
    <$InputContainer>
      <SwitchInput
        {...props}
        checkedChildren={'vero'}
        unCheckedChildren={'falso'}
      />
    </$InputContainer>
  );
}
